/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type CustomPropertyLinkRuleType = typeof CustomPropertyLinkRuleType[keyof typeof CustomPropertyLinkRuleType];


export const CustomPropertyLinkRuleType = {
  NOTAPPLICABLE: 'NOTAPPLICABLE',
  CALL: 'CALL',
  MAILTO: 'MAILTO',
  OPENINTAB: 'OPENINTAB',
  OPENINAPP: 'OPENINAPP',
  AUTOOPENINTAB: 'AUTOOPENINTAB',
  AUTOOPENINAPP: 'AUTOOPENINAPP',
} as const;
